// An event-day job device (card 540f21a4): a laptop or iPad paired to one
// event with one job, no account. What it keeps in this browser:
//   { token, eventKind, eventId, eventName, roleName, label }
// under its own key, so the app's sign-out (which clears the organizer's and
// parents' keys) never touches it, and ending it removes only this key.
const KEY = 'feislinkJobDevice';
const TOKEN_RE = /^[A-Za-z0-9_-]{32}$/;

const store = () => {
  try {
    return window.localStorage;
  } catch (e) {
    return null;
  }
};

export function readDevice() {
  try {
    const raw = store()?.getItem(KEY);
    const d = raw ? JSON.parse(raw) : null;
    return d && TOKEN_RE.test(d.token || '') ? d : null;
  } catch (e) {
    return null;
  }
}

export function saveDevice(device) {
  try {
    store()?.setItem(KEY, JSON.stringify(device));
  } catch (e) {
    // a browser that won't store it can't be a device
  }
}

export function forgetDevice() {
  try {
    store()?.removeItem(KEY);
  } catch (e) {
    // nothing stored
  }
}

export const isDeviceMode = () => !!readDevice();
export const deviceToken = () => readDevice()?.token || null;
export const isToken = (t) => TOKEN_RE.test(t || '');

// localStorage.clear() (sign-out, ended sessions) without losing the device.
export function clearKeepingDevice() {
  const d = readDevice();
  try {
    store()?.clear();
  } catch (e) {
    // nothing to clear
  }
  if (d) saveDevice(d);
}
